import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, DatePipe } from '@angular/common'; // <-- Import this

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './core/components/admin/admin.component';
import { WebsiteComponent } from './core/components/website/website.component';
import { AdminModule } from './core/components/admin/admin.module';

import { WebsiteModule } from './core/components/website/website.module';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { LoginComponent } from './core/auth/login/login.component';
import { ProfileComponent } from './core/components/website/MSME/profile/profile.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
//import { PaginationComponent } from './shared/pagination/pagination.component';
//import { IAWebsiteModule } from './core/components/website/IAwebsite.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ApiHandlerService } from './shared/utils/api-handler.service';
import { InterceptService } from './shared/services/intercept.service';
import { TrimInputValueDirective } from './shared/directive/trim-input-value.directive';
import { FullCalenderComponent } from './core/components/full-calender/full-calender.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { PopupDialogComponent } from '../app/core/components/popup-dialog/popup-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips'; // Import MatChipModule
import { PreviewfileComponent } from './core/components/previewfile/previewfile.component';
import { ViewapproverremarksComponent } from './core/components/viewapproverremarks/viewapproverremarks.component';
import { ViewmsmedocumentsComponent } from './core/components/website/MSSIDC/viewmsmedocuments/viewmsmedocuments.component';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { SsoLandingComponent } from './core/auth/sso-landing/sso-landing.component';

//import { EventCreationComponent } from './core/components/website/IA/event-creation/event-creation.component';

//import { Observable } from 'rxjs';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};  

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsType: 'three-strings',  // Choose an animation type
  fgsSize: 80,               // Size of the loader
  fgsColor: '#FF0000',       // Loader color
  overlayColor: 'rgba(0, 0, 0, 0.5)', // Background overlay
  hasProgressBar: false,
  text: 'Loading...',
  textColor: '#FFFFFF',
 // logoUrl: 'assets/Images/loader.gif',  // Custom loader image
  pbThickness: 3
};

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    WebsiteComponent,
   
    //EventCreationComponent,
    
    LoginComponent,
         //FullCalenderComponent,
         PopupDialogComponent,
    //ProfileComponent
    PreviewfileComponent,
    ViewapproverremarksComponent,
    SsoLandingComponent,

        
  ],
  imports: [

    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule, MatButtonModule, MatCardModule, MatRadioModule, MatStepperModule,    
    //AdminModule,
    WebsiteModule,
    /*IAWebsiteModule,*/ //Test
    NgMultiSelectDropDownModule,
    /*FullCalendarModule,*/
    MatDialogModule,
    MatChipsModule,
    MatIconModule,

    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      //MatDatepickerModule,
      //MatNativeDateModule,


    }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
    
  ],
  providers: [DatePipe,
    ApiHandlerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-IN' }, // Use British date format
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },],
  bootstrap: [AppComponent]
})
export class AppModule { }

